import { EGlobalSearchItemType } from "../types/global-search";

// NOTE: Mirrors GLOBAL_SEARCH_MIN_QUERY_LENGTH on the server — below it the
// server answers with no groups, so the clients don't call it at all.
export const GLOBAL_SEARCH_MIN_QUERY_LENGTH = 2;

export const GLOBAL_SEARCH_DEBOUNCE_MS = 300;

export const GLOBAL_SEARCH_QUERY_KEY = "global-search";

// NOTE: Per-group cap for every category, server-backed or client-built, so
// the palette stays scannable.
export const GLOBAL_SEARCH_GROUP_LIMIT = 5;

// NOTE: NSAI-6853 — per-group cap of a category tab browsed with an empty box.
// One kind fills the whole list there, so it shows more than a search group.
export const GLOBAL_SEARCH_BROWSE_LIMIT = 8;

// NOTE: Categories whose destination has no mobile screen. The mobile palette
// hides them; web shows everything.
export const GLOBAL_SEARCH_WEB_ONLY_TYPES: readonly EGlobalSearchItemType[] = [
  EGlobalSearchItemType.DOC_RECOGNITION_DOCUMENT,
] as const;

// NOTE: Display order of groups in the palette. Anything not listed renders
// after these, in the order it arrived.
export const GLOBAL_SEARCH_GROUP_ORDER: readonly EGlobalSearchItemType[] = [
  EGlobalSearchItemType.PAGE,
  EGlobalSearchItemType.SETTINGS_OPTION,
  EGlobalSearchItemType.SETTINGS_TAB,
  EGlobalSearchItemType.CHAT,
  EGlobalSearchItemType.CHAT_MESSAGE,
  EGlobalSearchItemType.ASSISTANT,
  EGlobalSearchItemType.PROMPT,
  EGlobalSearchItemType.KNOWLEDGE_FILE,
  EGlobalSearchItemType.CHAT_FOLDER,
  EGlobalSearchItemType.PROJECT,
  EGlobalSearchItemType.ORGANIZATION,
  EGlobalSearchItemType.SKILL,
  EGlobalSearchItemType.CATALOG_SKILL,
  EGlobalSearchItemType.AUTOMATION,
  EGlobalSearchItemType.MARKETPLACE_AUTOMATION,
  EGlobalSearchItemType.MEETING,
  EGlobalSearchItemType.CALENDAR_EVENT,
  EGlobalSearchItemType.GENERATED_FILE,
  EGlobalSearchItemType.DOC_RECOGNITION_DOCUMENT,
  EGlobalSearchItemType.INTEGRATION_PROVIDER,
  EGlobalSearchItemType.INTEGRATION_CONNECTION,
  EGlobalSearchItemType.CUSTOM_INTEGRATION,
  EGlobalSearchItemType.CUSTOM_TOOL,
  EGlobalSearchItemType.MODEL,
  EGlobalSearchItemType.PROBE,
  EGlobalSearchItemType.MEMBER,
  EGlobalSearchItemType.INVITE,
  EGlobalSearchItemType.ROLE,
  EGlobalSearchItemType.API_KEY,
  EGlobalSearchItemType.MEMORY_FACT,
  EGlobalSearchItemType.CUSTOM_INSTRUCTIONS,
  EGlobalSearchItemType.NOTIFICATION,
  EGlobalSearchItemType.FAQ_ITEM,
  EGlobalSearchItemType.ACTION,
] as const;
